import React from "react";

const TitleTextCard = ({heading,title,text}) => {
  return (
    <>
      <div className="titletext-card-container">
        <h1>{heading}</h1>
        <h3>{title}</h3>
        <p>
          {text}
        </p>
      </div>
    </>
  );
};

export default TitleTextCard;
